module.exports = __webpack_public_path__ + "img/59.8c064e72.png";